import React from 'react';

export default function TermsOfService() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
      <div className="prose max-w-none">
        <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Agreement to Terms</h2>
        <p>By accessing Marine Fuel Boost, you agree to these Terms of Service and all applicable laws and regulations.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. Product Information</h2>
        <p>We strive to provide accurate product information but reserve the right to modify specifications without notice.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Pricing and Payment</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>All prices are in USD unless otherwise stated</li>
          <li>We accept major credit cards and secure payment methods</li>
          <li>Prices may change without notice</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Shipping and Delivery</h2>
        <p>We ship to most locations worldwide. Delivery times and costs vary by destination.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Product Usage</h2>
        <p>Our products must be used in accordance with provided instructions. We are not liable for improper use.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
        <p>Marine Fuel Boost shall not be liable for any indirect, incidental, or consequential damages.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Contact Information</h2>
        <p>For questions about these terms, please contact us at support@marinefuelboost.com</p>
      </div>
    </div>
  );
} 